import { LinkRoute } from '@/components/common/Link'
import { Icon } from '@/components/icons/Icon'

import styles from './HeaderLogo.module.scss'

export const HeaderLogo = () => (
  <LinkRoute aria-label='EDHREC' className={styles.container} href='/'>
    <span className={styles.icon}>
      <Icon name='edhrecGraphic' />
    </span>
    <span className={styles.text}>
      <Icon name='edhrecText' />
    </span>
  </LinkRoute>
)
